import { Calendar, CalendarWrapper } from "@/components";
import { useModal } from "@/contexts";
import { DAY_GROUP, useCheckInValue, useCheckOutValue } from "@/shared/client";
import { Center, Text } from "@chakra-ui/react";
import { MEDIA } from "@styles/common";
import dayjs from "dayjs";
import { CustomCheckBox, CustomDurationBox, CustomText, CustomWrapper } from "./dateSearchBar.style";

export const DateSearchBar = () => {
    const checkIn = useCheckInValue();
    const checkOut = useCheckOutValue();
    const duration = dayjs(checkOut).diff(dayjs(checkIn), "day");
    const { openModal, setModalContent, setIconName } = useModal();
    const handleDay = (date: string) => {
        const dayName = DAY_GROUP.filter((item, index) => {
            if (index === dayjs(date).day()) return item;
        });
        return `(${dayName[0].subTitle})`;
    };

    const onModal = () => {
        setModalContent(
            <CalendarWrapper>
                <Calendar />
            </CalendarWrapper>,
        );
        setIconName("close");
        openModal();
    };

    const { isMobile } = MEDIA();
    return (
        <CustomWrapper>
            <Center columnGap={isMobile ? "10px" : "50px"} cursor="pointer" onClick={onModal}>
                <CustomCheckBox>
                    <CustomText>Check-in</CustomText>
                    <Text fontSize={isMobile ? "14px" : "auto"}>
                        {checkIn}
                        {handleDay(checkIn)}
                    </Text>
                </CustomCheckBox>
                <CustomDurationBox>{duration}박</CustomDurationBox>
                <CustomCheckBox>
                    <CustomText>Check-out</CustomText>
                    <Text fontSize={isMobile ? "14px" : "auto"}>
                        {checkOut}
                        {handleDay(checkOut)}
                    </Text>
                </CustomCheckBox>
            </Center>
        </CustomWrapper>
    );
};
